import React from 'react'

import { getOperationTypeName } from '../../../containers/stocks/select/OperationType'
import Text from '../Text'
import UsersLoader, { useUser } from './user/_load/UserLoader'
import Grid from '../Grid'
import PlacesLoader, { usePlace } from './place/_load/PlaceLoader'
import { useTranslation } from 'react-i18next'

const Stock = ({ value }) => {
  const user = useUser()
  const place = usePlace()
  const { t: tListStocks } = useTranslation('listStocks')
  const { t } = useTranslation('components')
  const OPERATION_TYPE_OPTIONS = getOperationTypeName(tListStocks)

  return (
    <Grid border="solid 1px black" justify={'end'} style={{ gap: 20 }}>
      <Text inline>
        <b>{t('pdf.stock.item')}:</b> <span>{value.item.name}</span>
      </Text>
      <Text inline>
        <b>{t('pdf.stock.amount')}:</b> <span>{value.amount}</span>
      </Text>
      <Text inline>
        <b>{t('pdf.stock.operation')}:</b>{' '}
        <span>{`${OPERATION_TYPE_OPTIONS.find(i => i.id === value.operationType.id).name}`}</span>
      </Text>
      {user && (
        <Text inline>
          <b>{t('pdf.stock.user')}:</b> <span>{user.name}</span>
        </Text>
      )}
      {place && (
        <Text inline>
          <b>{t('pdf.stock.place')}:</b> <span>{place.name}</span>
        </Text>
      )}
    </Grid>
  )
}

const Wrapper = ({ value }) => {
  return (
    <UsersLoader id={value.fromUserId || value.toUserId}>
      <PlacesLoader id={value.fromPlaceId || value.toPlaceId}>
        <Stock value={value} />
      </PlacesLoader>
    </UsersLoader>
  )
}

export default Wrapper
